// Loads the facebook SDK asynchronously.
// Copied from facebook/_async_init.html.slim.
const fbAsyncLoad = () => {
  // Protection against double calling of this function
  const id = 'facebook-jssdk';
  if (window.FB || document.getElementById(id)) {
    return;
  }

  const firstScriptTag = document.getElementsByTagName('script')[0];
  const scriptElement = document.createElement('script');
  scriptElement.id = id;
  scriptElement.src = '//connect.facebook.net/en_US/sdk.js';
  (firstScriptTag.parentNode as ParentNode).insertBefore(
    scriptElement,
    firstScriptTag,
  );
};

// Loads the google client asynchronously.
// Copied from google/_async_init.html.slim.
const googleAsyncLoad = () => {
  // Protection against double calling of this function
  const id = 'google-jssdk';
  if (document.getElementById(id)) {
    return;
  }

  const scriptElement = document.createElement('script');
  scriptElement.id = id;
  scriptElement.async = true;
  // loadGoogle is a global defined by legacy Sprockets-loaded scripts.
  // Guard against ReferenceError on pages that don't include those scripts.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (typeof (window as any).loadGoogle === 'function') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    scriptElement.onload = (window as any).loadGoogle;
  }
  scriptElement.src = 'https://accounts.google.com/gsi/client';

  const firstScriptTag = document.getElementsByTagName('script')[0];
  (firstScriptTag.parentNode as ParentNode).insertBefore(
    scriptElement,
    firstScriptTag,
  );
};
// Loads the sign in with Apple SDK asynchronously.
export const appleAsyncLoad = () => {
  // Protection against double calling of this function
  const id = 'apple-jssdk';
  if (document.getElementById(id)) {
    return;
  }
  const firstScriptTag = document.getElementsByTagName('script')[0];
  const scriptElement = document.createElement('script');
  scriptElement.id = id;
  scriptElement.src = `//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js`;
  (firstScriptTag.parentNode as ParentNode).insertBefore(
    scriptElement,
    firstScriptTag,
  );
};

// Must be called for FB/Google sign in to work.
export const setUpThirdPartySignIn = () => {
  fbAsyncLoad();
  googleAsyncLoad();
  appleAsyncLoad();
};
